const awsmobile = {
  "aws_user_pools_web_client_id": "1r5h3t71ec0mujqdj7mf2vgfe3", //This id is referenced at
};


export default awsmobile;
